<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Empty layout -->
<!-- ----------------------------------------------------------------------------------------------------- -->
<empty-layout *ngIf="layout === 'empty'"></empty-layout>

<!-- Classy / Thin (unified — animates between modes) -->
<classy-layout *ngIf="layout === 'classy' || layout === 'thin'">
    <ng-container asideHeader>
        <aside-header></aside-header>
    </ng-container>

    <ng-container asideContentHeader>
        <aside-content-header></aside-content-header>
    </ng-container>

    <ng-container asideFooter>
        <aside-footer></aside-footer>
    </ng-container>
</classy-layout>

<!-- custom -->
<custom-layout *ngIf="layout === 'custom'"></custom-layout>

<!-- <settings></settings> -->
